<template>
  <div id="page-wrapper" v-if="loggedIn" class="hidden-xs">
    <div class="container">
      <div class="row page-section form-padding">
        <div class="col-md-4 col-xs-6">
          <div class="prepaid-form">
            <h5>{{ pageTitle }}</h5>
            <DropDown
              @on-change="selectState"
              title="Select State"
              valueName="stateName"
              :items="states"
            />
            <DropDown
              @on-change="selectBoard"
              title="Select Provider"
              valueName="name"
              :items="filteredBoards"
            />
            <div v-for="(question, index) in selectedServiceProviderQuestion" :key="index">
              <input
                type="tel"
                :placeholder="question.questionLabel"
                class="bill-payment__input"
                v-model="selectedCustomer[index]"
                :maxlength="question.maxLength"
                :minlength="question.minLength"
                v-if="question.numeric"
                quicklinks
                v-numericOnly
                @keyup="checkValidity()"
              />
              <input
                type="text"
                :placeholder="question.questionLabel"
                class="bill-payment__input"
                v-model="selectedCustomer[index]"
                :maxlength="question.maxLength"
                :minlength="question.minLength"
                v-else
                @keyup="checkValidity()"
              />
            </div>
            <div v-if="!billResponse||pageError">
              <p class="error-text mt-20" v-if="pageError">{{ pageError }}</p>
              <ActionButton title="Fetch Bill" @click="fetchBill" :disabled="disabled" />
            </div>
            <div v-else>
              <div class="row">
                <div class="col-md-12">
                  <input
                    v-if="selectedPartial||selectedPlan||!selectedBillFetch"
                    class="account-id__input"
                    type="text"
                    placeholder="Enter Amount"
                    v-model="selectedPlan"
                    :disabled="selectedBillFetch&&!selectedPartial"
                    v-numericOnly
                  />
                </div>
              </div>
              <p class="error-text mt-20" v-if="pageError">{{ pageError }}</p>
              <router-link
                :to="{
                  name: 'Bill Web',
                  params: {category: $route.params.category,
                  billResponse:
                  billResponse.responseInfo &&billResponse.responseInfo.responseMessage === 'Success'
                  ? billResponse
                  : false,
                  queryData: query
                  }}"
                class="no-underline"
              >
                <ActionButton title="Continue" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";
import DropDown from "@/components/DropDown/index";
export default {
  name: "PostpaidWeb",
  computed: {
    ...mapGetters([
      "filteredBoards",
      "states",
      "loggedIn",
      "selectedAccountNumber",
      "selectedBillFetch",
      "selectedPartial",
    ]),
    selectedPlan: {
      get() {
        return this.$store.state.recharge.selectedPlan;
      },
      set(value) {
        return this.$store.dispatch("selectPlan", {
          amount: value,
          description: "",
        });
      },
    },
    pageTitle: {
      get() {
        return this.$route.params.category === "gas"
          ? "Gas Bill Payment"
          : this.$route.params.category === "electricity"
          ? "Electricity Bill Payment"
          : this.$route.params.category === "water"
          ? "Electricity Bill Payment"
          : this.$route.params.category === "Insurance Renewal"
          ? "Insurance Renewal"
          : this.$route.params.category === "Fastag"
          ? "FasTag"
          : this.$route.params.category === "Loan Repayment"
          ? "Loan Repayment"
          : "Mobile Bill Payment";
      },
    },
  },
  data() {
    return {
      query: {},
      payment_mode: "prepaid",
      pageError: "",
      selectedCustomer: [],
      validationTextMobile: "",
      selectedState: "",
      selectedServiceProviderQuestion: [],
      selectedServiceProvider: "",
      validMobile: false,
      operatorsLoaded: false,
      amount_visible: false,
      billResponse: false,
      paymentMethod: [
        { displayName: "Prepaid", methodKey: "prepaid" },
        { displayName: "Postpaid", methodKey: "postpaid" },
      ],
      disabled: true,
    };
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "BILL_PAYMENT_SELECTED",
      propertyName: "BILL_TYPE",
      propertyValue: this.$route.params.category.toUpperCase(),
    });
    this.$store.dispatch("getBillers", this.$route.params.category);
    this.$store.dispatch("setRechargeOperator", "");
    this.$store.dispatch("setRechargeAccountId", "");
    this.$store.dispatch("selectPlan", {
      amount: "",
      description: "",
    });
  },
  components: { ActionButton, DropDown },
  methods: {
    selectState(event) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateName == event.target.value) {
          var code = this.states[i].code;
        }
      }
      this.selectedState = event.target.value;
      this.$store.dispatch("selectState", {
        id: code,
        name: this.selectedState,
      });
      this.$store.dispatch("filterBoards", "filter");
    },
    selectBoard(event) {
      this.selectedServiceProvider = event.target.value;
      this.$store.dispatch("setRechargeOperator", this.selectedServiceProvider);
      for (let i = 0; i < this.filteredBoards.length; i++) {
        if (this.filteredBoards[i].name === event.target.value) {
          this.selectedServiceProviderQuestion = this.filteredBoards[
            i
          ].questions;
          this.disabled = true;
          this.selectedCustomer = [];
          var billFetch = this.filteredBoards[i].billFetch;
          var partial = this.filteredBoards[i].partial;
          var bbps = this.filteredBoards[i].bbps;
        }
      }
      this.$store.dispatch("selectBoard", {
        name: event.target.value,
        question: this.selectedServiceProviderQuestion,
        billFetch: billFetch,
        partial: partial,
        bbps: bbps,
      });
    },
    fetchBill() {
      this.pageError = "";
      if (
        this.selectedState &&
        this.selectedServiceProvider &&
        this.selectedCustomer.length > 0
      ) {
        let questionLabelValue = this.selectedCustomer;
        let questionLabel = [];
        this.selectedServiceProviderQuestion.forEach(function (item, key) {
          let questionLabelItem = {};
          questionLabelItem.questionLabel = item.questionLabel;
          questionLabelItem.value = questionLabelValue[key];
          questionLabel.push(questionLabelItem);
        });
        // console.log(questionLabel)

        this.query = {
          deviceInfo: {
            ip: "103.82.208.39",
            initiatingChannel: "MOBB",
            imei: "843843843843",
            os: "sfdfkfdfdk",
            appName: "ePayLater-2.0",
            mac: "3C-97-0E-E4-1D-25",
            terminalId: "9911100048",
            geoCode: "77.1801,8.2784",
            ifsc: "",
          },
          transactionInfo: {
            name: this.selectedServiceProvider,
            questions: questionLabel,
          },
        };
        // console.log(this.query);

        if (this.selectedBillFetch) {
          this.pageError = "";
          this.$store
            .dispatch("getBill", {
              params: this.query,
            })
            .then((response) => {
              this.billResponse = response;
              if (response.responseInfo.responseMessage === "Success") {
                this.amount_visible = true;
                this.$store.dispatch("selectPlan", {
                  amount: this.billResponse.billDetail.netAmount,
                  description: "",
                });
              } else if (response.responseInfo.responseMessage === "Fail") {
                this.pageError = response.responseInfo.responseDescription;
                this.amount_visible = false;
              }
            })
            .catch((err) => {});
        } else {
          this.billResponse = true;
          this.amount_visible = false;
        }
      } else {
        this.pageError = "Please fill all the field.";
      }
    },
    checkValidity() {
      this.billResponse = false;
      this.amount_visible = false;
      this.$store.dispatch("selectPlan", {});
      this.disabled = this.selectedServiceProviderQuestion.some(
        (question, index) => {
          if (
            this.selectedCustomer[index] &&
            question.minLength <= this.selectedCustomer[index].length &&
            question.maxLength >= this.selectedCustomer[index].length
          ) {
            return false;
          } else {
            return true;
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.account-id {
  &__input {
    font-size: 20px;
    padding: 8px 16px;
    &::placeholder {
      font-size: 16px;
      color: #d6d4d4;
    }
    width: 100%;
    border-radius: 3px;
    border: solid 0.2px #d4d4d4;
    background-color: #ffffff;
    margin-top: 24px;
  }
}

.bbps-logo {
  margin-left: 1rem;
  width: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/PostpaidWeb.vue